import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';

function AdminContributorApps() {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [rejectingId, setRejectingId] = useState(null);
  const [rejectNotes, setRejectNotes] = useState('');

  const getToken = () => localStorage.getItem('accessToken');
  const headers = { Authorization: `Bearer ${getToken()}` };

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    setLoading(true);
    try {
      const res = await fetch('/api/admin/contributor-applications/list', { headers });
      const data = await res.json();
      setApplications(data.applications || []);
    } catch (e) {
      console.error('Failed to fetch applications:', e);
    }
    setLoading(false);
  };

  const handleApprove = async (id) => {
    if (!window.confirm('Approve this application? The user will be assigned as a moderator for their selected channels.')) return;
    try {
      const res = await fetch(`/api/admin/contributor-applications/${id}/approve`, {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' }
      });
      if (res.ok) {
        alert('Application approved! User is now a moderator.');
        fetchApplications();
      } else {
        const data = await res.json();
        alert(data.error || 'Failed to approve');
      }
    } catch (e) {
      alert('Error: ' + e.message);
    }
  };

  const handleReject = async (id) => {
    try {
      const res = await fetch(`/api/admin/contributor-applications/${id}/reject`, {
        method: 'POST',
        headers: { ...headers, 'Content-Type': 'application/json' },
        body: JSON.stringify({ notes: rejectNotes })
      });
      if (res.ok) {
        alert('Application rejected.');
        setRejectingId(null);
        setRejectNotes('');
        fetchApplications();
      } else {
        const data = await res.json();
        alert(data.error || 'Failed to reject');
      }
    } catch (e) {
      alert('Error: ' + e.message);
    }
  };

  return (
    <div>
      <Navbar />
      <div style={{ maxWidth: '900px', margin: '0 auto', padding: '24px' }}>
        <h1 style={{ marginBottom: '8px' }}>📋 Contributor Applications</h1>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          Review applications from users who want to become content moderators.
        </p>

        {loading ? (
          <p>Loading...</p>
        ) : applications.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
            <p style={{ fontSize: '1.2rem' }}>No pending applications</p>
            <p style={{ fontSize: '14px', marginTop: '8px' }}>New applications will appear here when users apply to contribute.</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {applications.map(app => (
              <div key={app.id} style={{ border: '1px solid #e5e7eb', borderRadius: '12px', padding: '20px', background: '#fff' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '12px' }}>
                  <div>
                    <strong style={{ fontSize: '16px' }}>{app.name}</strong>
                    <span style={{ color: '#6b7280', fontSize: '13px', marginLeft: '8px' }}>({app.email})</span>
                  </div>
                  <span style={{ fontSize: '12px', color: '#9ca3af' }}>
                    {new Date(app.created_at).toLocaleDateString()}
                  </span>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '6px' }}>Channels requested:</p>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                    {app.channels.map((ch, i) => (
                      <span key={i} style={{ background: '#ede9fe', color: '#7c3aed', padding: '3px 10px', borderRadius: '6px', fontSize: '13px' }}>
                        {ch.name} <span style={{ color: '#a78bfa', fontSize: '11px' }}>({ch.category_name})</span>
                      </span>
                    ))}
                  </div>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <p style={{ fontSize: '13px', color: '#6b7280', marginBottom: '4px' }}>Why they want to contribute:</p>
                  <p style={{ fontSize: '14px', color: '#374151', lineHeight: '1.6', background: '#f9fafb', padding: '12px', borderRadius: '8px', whiteSpace: 'pre-wrap' }}>
                    {app.reason}
                  </p>
                </div>

                {rejectingId === app.id ? (
                  <div style={{ border: '1px solid #fecaca', borderRadius: '8px', padding: '12px', background: '#fef2f2' }}>
                    <textarea
                      value={rejectNotes}
                      onChange={(e) => setRejectNotes(e.target.value)}
                      placeholder="Optional: Add a note explaining why (visible to applicant)..."
                      style={{ width: '100%', minHeight: '60px', padding: '8px', borderRadius: '6px', border: '1px solid #d1d5db', fontFamily: 'inherit', fontSize: '13px', resize: 'vertical', marginBottom: '8px' }}
                    />
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        onClick={() => handleReject(app.id)}
                        style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer', fontSize: '13px' }}
                      >
                        Confirm Reject
                      </button>
                      <button
                        onClick={() => { setRejectingId(null); setRejectNotes(''); }}
                        style={{ padding: '8px 16px', borderRadius: '6px', border: '1px solid #d1d5db', background: '#fff', cursor: 'pointer', fontSize: '13px' }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button
                      onClick={() => handleApprove(app.id)}
                      style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#10b981', color: '#fff', cursor: 'pointer', fontWeight: 500 }}
                    >
                      ✅ Approve & Assign
                    </button>
                    <button
                      onClick={() => setRejectingId(app.id)}
                      style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', background: '#ef4444', color: '#fff', cursor: 'pointer', fontWeight: 500 }}
                    >
                      ❌ Reject
                    </button>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminContributorApps;
